import { useState, useEffect } from 'react';
import { MdDownload, MdClose } from 'react-icons/md';

const STORAGE_KEY = 'ta_install_dismissed';

export default function InstallHint() {
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;

    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    if (isStandalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') dismiss();
    }
    dismiss();
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(STORAGE_KEY, '1');
  };

  if (!show) return null;

  return (
    /* On mobile the bottom bar is 56px — position hint above it */
    <div className="fixed bottom-[72px] md:bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 bg-card border border-divider rounded-2xl shadow-xl p-4 flex items-start gap-3">
      <div className="w-9 h-9 bg-primary rounded-xl flex items-center justify-center flex-shrink-0">
        <MdDownload className="text-white text-xl" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-secondary">Add TrainAxis to your home screen</p>
        <p className="text-xs text-muted mt-0.5">Faster access — works like a native app, no app store needed.</p>
        <button
          onClick={handleInstall}
          className="mt-2 text-xs font-semibold text-primary hover:underline"
        >
          Install now
        </button>
      </div>
      <button
        onClick={dismiss}
        className="text-muted hover:text-secondary transition-colors flex-shrink-0 mt-0.5"
        aria-label="Dismiss"
      >
        <MdClose className="text-lg" />
      </button>
    </div>
  );
}
